import React, { Component } from "react";

import { setDepthOfPit } from "util/aws-manager";
import Button from "material-ui/Button";
import {
  extractDataForPdf
} from "util/aws-manager";
import {
  CardText,
} from "reactstrap";
import SearchBox from "components/SearchBox";
import { searchDevices } from "util/aws-manager";
import { highlightNavigatedMenu } from "util/highlightSidebarOption";
import moment from "moment";
import { connect } from "react-redux";
import _ from "lodash";
import EnhancedTable from './EnhancedTable';

class DataExtract extends Component {
  currentPath;
  constructor(props) {
    super(props);
    this.state = {
    };
  }
  componentDidMount() {
    // extractDataForPdf(this.props.deviceId)
    //   .then((data) => {
    //     this.props.updateExtractData({ data, pageNumber: this.props.dataExtract.pageNumber });
    //   })
    //   .catch((error) => {
    //     console.log('error: ', error);
    //   })
    this.currentPath = this.props.location.pathname;
  }

  componentWillMount() {
    this.unlisten = this.props.history.listen((location) => {
      this.currentPath = location.pathname;
    });
  }

  componentWillUnmount() {
    this.unlisten();
  }

  render() {
    return (
      <div className="row configuration-page">
        <div className="col-12">
          <div className="jr-card d-sm-flex justify-content-sm-between align-items-sm-center">
            <div className="col-12 col-sm-6 col-lg-10">
              <h1 className="mb-0">Download Data</h1>
            </div>
            <div className="col-12 col-sm-6 col-lg-2">
              {/* Device ID: {this.props.deviceId} */}
            </div>
          </div>
        </div>
        <div className="col-12">
          <div className="row" id={'print'}>
            <EnhancedTable updateDeviceId={(deviceId) => {
              this.props.updateDeviceId(deviceId);
              if (
                !(
                  this.currentPath === "/app/components/heartbeat" ||
                  this.currentPath === "/app/components/notifications"
                )
              ) {
                highlightNavigatedMenu("heartbeat", `#${this.currentPath}`);
                this.props.history.push("/app/components/heartbeat");
              }
            }} />
            {/* <button onClick={()=>{
              const printableElements = document.getElementById('print').innerHTML;
              const orderHtml = '<html><head><title></title></head><body>' + printableElements + '</body></html>';
              const oldPage = document.body.innerHTML;
              document.body.innerHTML = orderHtml;
              window.print();
              document.body.innerHTML = oldPage
            }}>
              
            </button> */}
          </div>
        </div>
      </div>
    );
  }
}

const mapStateToProps = ({ symbioticReducer }) => {
  return {
    deviceId: symbioticReducer.deviceId,
    dataExtract: symbioticReducer.dataExtract,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    updateDeviceId: (id) => {
      dispatch({ type: "UPDATE_DEVICE_ID", deviceId: id });
    },
    updateExtractData: (data) => {
      dispatch({ type: "EXTRACT_DATA", dataExtract: data });
    },
  }
};

export default connect(mapStateToProps, mapDispatchToProps)(DataExtract);



// WEBPACK FOOTER //
// ./app/routes/dataExtract/index.js